import styled from 'styled-components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';

export const FiltersWrapperStyled = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  gap: 3rem;
  padding: 0;
  margin-bottom: 5rem;
  list-style: none;

  ${breakpointsMQ4.xl.down} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FilterSectionStyled = styled.div`
  display: flex;
  gap: 3rem;
  align-items: flex-end;
  flex-wrap: wrap;
  justify-content: center;
`;

export const AdditionalFiltersSectionStyled = styled.div`
  display: flex;
  gap: 3rem;
  margin-top: 3rem;
`;
